import {Component, React} from "react";
import { Redirect } from 'react-router-dom';
import {IoIosArrowBack} from "react-icons/io";
import ApiSso from "../../../actions/sso";
import Api from "../../../actions/api";
import toastr from "toastr";
import LoadingComponent from "../../../components/LoadingComponent/LoadingComponent";


class OneClick extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            planName: null,
            planPrice: null
        }
    }

    componentDidMount() {
        this.auth().then(authResponse => {
            let plan = localStorage.getItem('user_plan_id');
            Api.defaults.headers.common['Authorization'] = authResponse.data.data.token;
            Api.get('pack/id/' + plan, {}).then((response) => {
                localStorage.setItem('user_plan_id', response.data.data.id);
                localStorage.setItem('user_plan_name', response.data.data.name);
                localStorage.setItem('user_plan_price', response.data.data.value);

                this.setState({
                    planName: response.data.data.name,
                    planPrice: response.data.data.value
                });
            })
        })
    }

    auth() {
        const client = process.env.REACT_APP_CLIENT;
        const key = process.env.REACT_APP_KEY;

        return ApiSso.post('client', {
            'client': client,
            'key': key
        });
    }
    handleClick(){
        this.setState({isLoading: true});
        let account = localStorage.getItem("account");
        let email = localStorage.getItem('email');
        this.auth().then(authResponse  => {
            Api.defaults.headers.common['Authorization'] = authResponse.data.data.token;
            Api.post('payment/one-click', {
                'account_id': account,
                'email': email
            }).then((response) => {

                this.setState({isLoading: false});
                localStorage.setItem('payment-success', true);
                localStorage.setItem('cart', response.data.data.cart_id);

                setTimeout(() => {
                    let processing = false;
                    this.props.history.push("/dashboard");
                    window.location.reload();
                }, 2000);

            }).catch((error) => {
                this.setState({ isLoading: false });
              
                toastr.options = {
                  positionClass: 'toast-top-full-width',
                  hideDuration: 3000,
                  timeOut: 10000
                };
              
                toastr.clear();

                toastr.error(error);
              
                setTimeout(() => {
                  this.props.history.push("/payment");
                  window.location.reload();
                }, 3000);
              });
              
        })
    }

    render(){

        if(!localStorage.getItem("token")){
            return (
                <Redirect to="/" />
            )
        }

        return (
            <div onClick={() => this.handleClick()} className="selected-plan mb-4">
              {this.state.isLoading ? (
                <LoadingComponent />
              ) : null}
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                <IoIosArrowBack style={{ textAlign: 'left' }} />
                <small>Você está a um passo de comprar o seu plano de Telemedicina</small>
              </div>
              <h2>{this.state.planName}</h2>
              <h4 className="price">
                <span>R$</span>
                {this.state.planPrice !== null ? Number(this.state.planPrice).toFixed(2) : null}
                <span>/mês</span>
              </h4>
            </div>
          );
          
          
          
    }
}

export default OneClick;